var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z",
    fill: "#005809"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28997 7.78981C5.18997 7.78981 5.09497 7.7498 5.02497 7.67981L3.60997 6.2648C3.46497 6.1198 3.46497 5.8798 3.60997 5.7348C3.75497 5.5898 3.99497 5.5898 4.13997 5.7348L5.28997 6.88481L7.85997 4.3148C8.00497 4.1698 8.24497 4.1698 8.38997 4.3148C8.53497 4.4598 8.53497 4.6998 8.38997 4.8448L5.55497 7.67981C5.48497 7.7498 5.38997 7.78981 5.28997 7.78981Z",
    fill: "#005809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.edbeff0ff91524cbf45a09d494a21b40.svg";
export { ForwardRef as ReactComponent };